<div class="customer-access-container d-flex flex-column justify-content-center" [ngStyle]="{'overflow-y': 'auto','height' : panelHeight}">
  <div class="d-flex flex-row justify-content-center">
    <div class="customer-card-container">
      <div class="card border-0 shadow-sm">
        <div class="card-header d-flex flex-wrap align-items-center bg-dark text-white">
          <span class="pt-1 header-title">Select Customer</span>
        </div>
        <div class="p-4">
          <div class="input-group search-container mb-3">
            <input type="text" class="form-control search-input" placeholder="Search customers..." 
              (input)="searchCustomers($event)" [value]="searchTerm">
            <div class="input-group-append">
              <span class="input-group-text search-icon"><i class="fa fa-search"></i></span>
            </div>
          </div>
        </div>
        <div class="card-body customer-list-container px-4">
          <div class="row mx-0">
            <div *ngFor="let customer of filteredCustomerList" class="custom-control custom-radio display-flex p-2 col-12">
              <input type="radio" [checked]="customer == selectedCustomer" [value]="customer" [name]="customer"
                (click)="setSelectedCustomer(customer)" id="si_{{customer}}" class="custom-control-input me-2">
              <label class="custom-control-label customer-label" for="si_{{customer}}">{{customer}}</label>
            </div>
          </div>
        </div>
        <div class="card-footer text-muted p-3 d-flex justify-content-end">
          <button class="btn btn-primary px-4" (click)="submit()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

